module.exports = __webpack_public_path__ + "img/search-close.c0857b12.png";